import { useEffect, useState } from "react";
import api from "../../../conf/api";

/**
 * Which render engine CreatorVault runs on: "vre" or "creatomate".
 *
 * The backend decides (RENDER_ENGINE) and says so at GET /mrss/render-engine/,
 * so one setting switches the editor, the template pickers and the renders
 * together. Asked once per page load and shared by every caller.
 */
let cachedEngine = null;
let pending = null;

export function fetchRenderEngine() {
  if (cachedEngine) return Promise.resolve(cachedEngine);
  if (!pending) {
    pending = api
      .get("/mrss/render-engine/")
      .then((res) => {
        cachedEngine = res.data?.engine === "creatomate" ? "creatomate" : "vre";
        return cachedEngine;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

/**
 * `{ engine, error }` — engine is null until known. Nothing is fetched while
 * `enabled` is false, so a closed dialog costs no request.
 */
export default function useRenderEngine(enabled = true) {
  const [engine, setEngine] = useState(cachedEngine);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || engine) return undefined;
    let live = true;
    fetchRenderEngine()
      .then((value) => live && setEngine(value))
      .catch((err) => live && setError(err));
    return () => {
      live = false;
    };
  }, [enabled, engine]);

  return { engine, error };
}
